export default __webpack_public_path__ + "static/media/template7.15cfcb9b.svg";